import HttpResponse from "../../../../utils/http/http.response";

type CandidatureAddSuccessResponse = HttpResponse<string>;

export enum CandidatureAddNotAcceptableResponseErrorType {
  NO_TAXI_DRIVER_ASSOCIATION = "NO_TAXI_DRIVER_ASSOCIATION",
  NO_VALID_TAXI_DRIVER_CONTRACT = "NO_VALID_TAXI_DRIVER_CONTRACT",
  NO_VALID_TAXI_RAILY_CONTRACT = "NO_VALID_TAXI_RAILY_CONTRACT",
  NO_VALID_CARGO_RAILY_CONTRACT = "NO_VALID_CARGO_RAILY_CONTRACT",
  TARGET_PLAN_ENTRY_NOT_FOUND = "TARGET_PLAN_ENTRY_NOT_FOUND",
  CANDIDATE_FITS_WITH_NOT_ENOUGH_TIME = "CANDIDATE_FITS_WITH_NOT_ENOUGH_TIME",
  CANDIDATE_DOES_NOT_FIT = "CANDIDATE_DOES_NOT_FIT",
  TOO_MANY_CHECKOUT_EVENTS = "TOO_MANY_CHECKOUT_EVENTS",
  CANDIDATE_FITS_WITH_PLAN_ENTRY_COLLISION = "CANDIDATE_FITS_WITH_PLAN_ENTRY_COLLISION",
  DELETE_SOLVED_ORDER_TARGET_NOT_FOUND = "DELETE_SOLVED_ORDER_TARGET_NOT_FOUND",
  PLAN_ENTRY_CANDIDATE_COLLISION = "PLAN_ENTRY_CANDIDATE_COLLISION",
  FORBIDDEN_TAXI = "FORBIDDEN_TAXI",
  FORBIDDEN_PLAN_ENTRY = "FORBIDDEN_PLAN_ENTRY",
}

export type CandidatureAddNotAcceptableResponseNoTaxiDriverAssociationError = {
  errorType: CandidatureAddNotAcceptableResponseErrorType.NO_TAXI_DRIVER_ASSOCIATION;
  driverId: string;
  taxiId: string;
};

export type CandidatureAddNotAcceptableResponseNoValidTaxiDriverContractError =
  {
    errorType: CandidatureAddNotAcceptableResponseErrorType.NO_VALID_TAXI_DRIVER_CONTRACT;
    driverId: string;
    taxiId: string;
  };

export type CandidatureAddNotAcceptableResponseNoValidTaxiRailyContractError = {
  errorType: CandidatureAddNotAcceptableResponseErrorType.NO_VALID_TAXI_RAILY_CONTRACT;
};

export type CandidatureAddNotAcceptableResponseNoValidCargoRailyContractError =
  {
    errorType: CandidatureAddNotAcceptableResponseErrorType.NO_VALID_CARGO_RAILY_CONTRACT;
    driverId: string;
    taxiId: string;
  };

export type CandidatureAddNotAcceptableResponseTargetPlanEntryNotFoundError = {
  errorType: CandidatureAddNotAcceptableResponseErrorType.TARGET_PLAN_ENTRY_NOT_FOUND;
  candidateEntryId: string;
  targetPlanEntryId: string;
};

export type CandidatureAddNotAcceptableResponseCandidateFitsWithNotEnoughTimeError =
  {
    errorType: CandidatureAddNotAcceptableResponseErrorType.CANDIDATE_FITS_WITH_NOT_ENOUGH_TIME;
    candidatureId: string;
    candidatureEntryId: string;
    collidingSolvedOrderId: string;
    candidatureSolvedOrderId: string;
  };

export type CandidatureAddNotAcceptableResponseTooManyCheckoutEventsError = {
  errorType: CandidatureAddNotAcceptableResponseErrorType.TOO_MANY_CHECKOUT_EVENTS;
};

export type CandidatureAddNotAcceptableResponseCandidateDoesNotFitError = {
  errorType: CandidatureAddNotAcceptableResponseErrorType.CANDIDATE_DOES_NOT_FIT;
  candidatureId: string;
  candidatureEntryId: string;
  candidatureSolvedOrderId: string;
};

export type CandidatureAddNotAcceptableResponseCandidatePlanEntryCollidesError =
  {
    errorType: CandidatureAddNotAcceptableResponseErrorType.CANDIDATE_FITS_WITH_PLAN_ENTRY_COLLISION;
    candidatureId: string;
    candidatureEntryId: string;
    candidaturePlanEntryId: string;
  };

export type CandidatureAddNotAcceptableResponseDeleteSolvedOrderTargetNotFoundError =
  {
    errorType: CandidatureAddNotAcceptableResponseErrorType.DELETE_SOLVED_ORDER_TARGET_NOT_FOUND;
    candidatureId: string;
    candidateEntryId: string;
    targetSolvedOrderId: string;
  };

export type CandidatureAddNotAcceptableResponsePlanEntryCandidateCollisionError =
  {
    errorType: CandidatureAddNotAcceptableResponseErrorType.PLAN_ENTRY_CANDIDATE_COLLISION;
    candidatureId: string;
    candidateEntryId: string;
  };

export type CandidatureAddNotAcceptableResponseForbiddenTaxiError = {
  errorType: CandidatureAddNotAcceptableResponseErrorType.FORBIDDEN_TAXI;
  providedTaxiId: string;
};

export type CandidatureAddNotAcceptableResponseForbiddenPlanEntryError = {
  errorType: CandidatureAddNotAcceptableResponseErrorType.FORBIDDEN_PLAN_ENTRY;
  providedPlanEntryId: string;
};

export type CandidatureAddNotAcceptableResponseError =
  | CandidatureAddNotAcceptableResponseNoTaxiDriverAssociationError
  | CandidatureAddNotAcceptableResponseNoValidTaxiDriverContractError
  | CandidatureAddNotAcceptableResponseNoValidTaxiRailyContractError
  | CandidatureAddNotAcceptableResponseNoValidCargoRailyContractError
  | CandidatureAddNotAcceptableResponseTargetPlanEntryNotFoundError
  | CandidatureAddNotAcceptableResponseCandidateFitsWithNotEnoughTimeError
  | CandidatureAddNotAcceptableResponseCandidateDoesNotFitError
  | CandidatureAddNotAcceptableResponseCandidatePlanEntryCollidesError
  | CandidatureAddNotAcceptableResponseDeleteSolvedOrderTargetNotFoundError
  | CandidatureAddNotAcceptableResponsePlanEntryCandidateCollisionError
  | CandidatureAddNotAcceptableResponseForbiddenTaxiError
  | CandidatureAddNotAcceptableResponseForbiddenPlanEntryError
  | CandidatureAddNotAcceptableResponseTooManyCheckoutEventsError;

export type CandidatureAddNotAcceptableResponse =
  HttpResponse<CandidatureAddNotAcceptableResponseError>;

type CandidatureAddResponse =
  | CandidatureAddSuccessResponse
  | CandidatureAddNotAcceptableResponse;

export default CandidatureAddResponse;
